/* Moved from sections/hlth-faq.liquid so browsers cache it (speed audit item 6, 16 Oct 2026); loaded async where the
   inline script was. */
(function () {
  function run(SID) {
      (function() {
        var root = document.querySelector('.hlth-faq-' + SID + '');
        if (!root) return;

        root.querySelectorAll('details.hlth-faq__item').forEach(function(details) {
          var summary = details.querySelector('summary');
          var panel = details.querySelector('.hlth-faq__answer');
          if (!summary || !panel) return;

          summary.addEventListener('click', function(e) {
            e.preventDefault();

            if (details.open) {
              /* Collapse */
              panel.style.height = panel.scrollHeight + 'px';
              requestAnimationFrame(function() {
                panel.style.height = '0';
                panel.style.opacity = '0';
              });
              panel.addEventListener('transitionend', function handler(ev) {
                if (ev.propertyName !== 'height') return;
                panel.removeEventListener('transitionend', handler);
                details.open = false;
              });
            } else {
              /* Expand */
              details.open = true;
              var h = panel.scrollHeight;
              panel.style.height = '0';
              panel.style.opacity = '0';
              requestAnimationFrame(function() {
                panel.style.height = h + 'px';
                panel.style.opacity = '1';
              });
              panel.addEventListener('transitionend', function handler(ev) {
                if (ev.propertyName !== 'height') return;
                panel.removeEventListener('transitionend', handler);
                panel.style.height = 'auto';
              });
            }
          });
        });
      })();
  }
  function scan(scope) {
    var list = [];
    if (scope.classList && scope.classList.contains('hlth-s--hlth-faq')) list.push(scope);
    scope.querySelectorAll('.hlth-s--hlth-faq').forEach(function (w) { list.push(w); });
    list.forEach(function (w) {
      if (w.__hlthJs_hlth_faq) return;
      w.__hlthJs_hlth_faq = true;
      run(w.id.replace(/^shopify-section-/, ''));
    });
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
